// extracted by mini-css-extract-plugin
export default {"bank":"style_bank__YFcZ-","chip":"style_chip__bMDsn","value":"style_value__gDb2C"};